import { EMPTY_PLACEHOLDER, formatNumber, formatPercent, isEmptyNumber } from '@shared/lib/format';

/**
 * 펀드 지표 표기(기존 코드의 FormatIndicator 규칙).
 * 금액은 백만원 단위 + 천 단위 쉼표("13,300 백만원" — Figma 예시대로 띄어 쓴다).
 */
export const FUND_MILLION_UNIT = '백만원';

/** 원 → "13,300 백만원". 값이 없으면 "-" */
export function formatMillionWon(value: number | null | undefined): string {
  if (isEmptyNumber(value)) return EMPTY_PLACEHOLDER;
  return `${formatNumber(value / 1_000_000)} ${FUND_MILLION_UNIT}`;
}

/** 0~1 비율 → "18.4%". 1% 미만이거나 없으면 "-" */
export function formatFundPercent(ratio: number | null | undefined): string {
  if (isEmptyNumber(ratio) || ratio < 0.01) return EMPTY_PLACEHOLDER;
  return formatPercent(ratio, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

/** 배수 → "1.8 X". 1 미만이거나 없으면 "-" */
export function formatMultiple(value: number | null | undefined): string {
  if (isEmptyNumber(value) || value < 1) return EMPTY_PLACEHOLDER;
  return `${formatNumber(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} X`;
}

/** 소수 둘째 자리 → "1.24". 없으면 "-" */
export function formatRatio2(value: number | null | undefined): string {
  if (isEmptyNumber(value)) return EMPTY_PLACEHOLDER;
  return formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
